import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {EMPTY, Observable, of} from 'rxjs';
import {StorageService} from '../provider/storage/storage.service';
import {IQApiService} from '../provider/iqapi/iqapi.service';
import {MessagesService} from '../provider/messages/messages.service';
import {ConfigurationObject, SearchObjectsExObj} from '../interfaces/interfaces.regisafe';
import {APP_ROUTES} from '../../environments/environment';
import {catchError, mergeMap} from 'rxjs/operators';
import {UserService} from '../provider/user/user.service';
import {AppConfig} from '../app.config';

@Injectable({
	providedIn: 'root'
})
export class DetailResolver implements Resolve<Observable<any>> {

	public configuration: ConfigurationObject;

	constructor(private storageService: StorageService,
				private userService: UserService,
				private iqAPI: IQApiService,
				private router: Router,
				private msgService: MessagesService,
				public appConfig: AppConfig) {

		this.configuration = this.appConfig.getConfig();

	}

	// eslint-disable-next-line max-len
	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Observable<any>> | Promise<Observable<any>> | Observable<any> {

		// BODY Object erstellen
		const body: SearchObjectsExObj = {};

		body.osId = route.params.osid;
		body.objIDs = this.userService.objIdAsIQAPIParam(route.params.objid);
		body.apiID = this.configuration.iqapiAppId;
		body.sessionToken = this.storageService.getToken();
		body.prepareRights = 1;

		const fields = this.storageService.getOSFieldsFromCondtionsSync(body.osId);
		fields.push('_Rechte');
		fields.push('_Zeitstempel');
		body.fields = fields.join(',');

		console.log('### DETAIL Body ### : ', body);

		return this.iqAPI.orgaManagerReadObjects(body).pipe(
			catchError((e) => {
				let errorMsg: string;
				if (e.error.hasOwnProperty('_error')) {
					// eslint-disable-next-line no-underscore-dangle
					errorMsg = e.error._error['1'].hl + ': ' + e.error._error['1'].eMsg;
				} else {
					errorMsg = e.message;
				}
				this.msgService.sendMessage({context: 'detailresolver:catcherror', text: errorMsg, error: e});
				return EMPTY;
			}),
			mergeMap((data) => {
				if (data.objDatasets[0].Text === '') {
					this.router.navigate([APP_ROUTES.suche]).then((e) => {
						this.msgService.sendMessage({
							context: 'detailresolver:noresults', text: 'Es wurden keine Ergebnisse gefunden.'
						});
					});
					return EMPTY;
				} else {
					return of(data);
				}
			})
		);

	}
}

